<template>
  <div>
    <!-- <img src="@/assets/images/dpng.png" alt="" /> -->
    <Navbar />
    <router-view />
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
import Navbar from './components/Navbar'

export default {
  components: {
    Navbar
  }
}
</script>

<style lang="sass">
@import './assets/sass/buefy.scss'
</style>
